import RouteSectionsPrefixes from "@/entities/RouteSectionsPrefixes";
import {
  getCompanyPrivatePageRoutes,
  getCompaniesRoutes,
} from "@/router/contractor/pages/companies";
import {
  getProjectPrivatePageRoutes,
  getProjectsRoutes,
  getProjectPrivatePageTabsRoutes,
} from "@/router/contractor/pages/projects";
import {
  getCompanyPostingsRoutes,
  getMarketPlacePostingsRoutes,
  getPostingsTabsRoutes,
  getPostingPrivatePageRoutes,
  getApplicationsRoutes,
  getPostingsRoutes,
} from "@/router/contractor/pages/postings";
import { getDocumentsRoutes } from "@/router/contractor/pages/documents";
import { getConnectionsRoutes } from "@/router/contractor/pages/connections";
import Route from "@/entities/Route";

export const contractorRoutes: Route[] = [
  ...getApplicationsRoutes({
    children: [
      ...getPostingPrivatePageRoutes({
        prefix: RouteSectionsPrefixes.APPLICATIONS,
        breadcrumbTitle: "Application details",
      }),
    ],
  }),
  ...getProjectsRoutes({
    children: [
      ...getProjectPrivatePageRoutes({
        // children: [
        //   ...getProjectPrivatePageTabsRoutes({}),
        // ],
      }),
    ],
  }),
  ...getPostingsRoutes({
    children: [
      ...getPostingsTabsRoutes({
        children: [
          ...getMarketPlacePostingsRoutes({}),
          ...getCompanyPostingsRoutes({}),
        ],
      }),
      ...getPostingPrivatePageRoutes({}),
    ],
  }),
  ...getDocumentsRoutes({}),
  ...getConnectionsRoutes({}),
  ...getCompaniesRoutes({
    children: [...getCompanyPrivatePageRoutes({})],
  }),
];
